import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ReadExcelForm from '../forms/read-excel-form';
import { excelReadValidationSchema } from '../schema/excel.js';

export default function ReadExcelNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Read Excel Node Details',
        altText: 'Read Excel Node',
        defaultLabel: 'Read Excel Node',
      }}
    >
      <CommonNode FormComponent={ReadExcelForm} schemaResolver={excelReadValidationSchema} />
    </NodeProvider>
  );
}
